module.exports = __webpack_public_path__ + "0c29638c7558632a1a5f053d344405ba.png";